/*
 * Casa loyalty "earn points" banner on the product page (Figma 4501:4181).
 *
 * The app writes its own sentence ("Earn 2,500 coco coins on this purchase."), which can not be translated in the theme
 * and has no bold part. This swaps it for the theme's translatable sentence (product.general.coco_coins_html, rendered in
 * a <template class="coco-coins-text"> by snippets/product-info.liquid) with the points taken from the app's text. The
 * app can rewrite its text later (variant change, points loaded), so changes are watched and the swap runs again.
 *
 * Outside the product page the app block does not render, so buy blocks there use the theme's own banner
 * (snippets/coco-coins-banner.liquid, [data-coco-coins-banner]). Its points are a Liquid estimate; here they are
 * replaced by the app's number, asked from the app's proxy the way the app does it (once per variant).
 */
(() => {
  if (window.cocoCoinsText) {
    return;
  }

  window.cocoCoinsText = true;

  const apply = () => {
    const template = document.querySelector('template.coco-coins-text');

    if (!template) {
      return;
    }

    const html = template.innerHTML.trim();

    document.querySelectorAll('.casa_points_text').forEach((element) => {
      if (element.closest('[data-coco-coins-banner]')) {
        return; // the theme's banner, see loadPoints
      }

      if (element.dataset.cocoCoins === element.textContent) {
        return; // already ours
      }

      const points = element.textContent.match(/\d[\d.,\s]*\d|\d/);

      if (!points) {
        return;
      }

      element.innerHTML = html.replace('__POINTS__', points[0].trim());
      element.dataset.cocoCoins = element.textContent;
    });
  };

  const loadPoints = (banner) => {
    const { endpoint, productId, variantId, price, customerId, tags } = banner.dataset;

    if (banner.dataset.loaded === variantId) {
      return;
    }

    banner.dataset.loaded = variantId;

    let productTags = [];

    try {
      productTags = JSON.parse(tags || '[]');
    } catch (error) {
      // no tags then
    }

    fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({
        type: 'product',
        product_price: price,
        product_id: productId,
        variant_id: variantId,
        product_tags: productTags,
        shopLocale: window.Shopify?.locale || null,
        customerId: customerId || null
      })
    })
      .then((response) => response.json())
      .then((data) => {
        if (!banner.isConnected || banner.dataset.variantId !== variantId) {
          return;
        }

        if (data.customerExcluded || !(data.points_earned_value > 0)) {
          banner.hidden = true;
          return;
        }

        banner.querySelector('.casa_points_text').innerHTML = banner.dataset.template.replace('__POINTS__', data.points_earned);
        banner.hidden = false;
      })
      .catch(() => {
        // keep the estimate
      });
  };

  const applyBanners = () => {
    document.querySelectorAll('[data-coco-coins-banner]').forEach(loadPoints);
  };

  let scheduled = false;

  const schedule = () => {
    if (scheduled) {
      return;
    }

    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      apply();
      applyBanners();
    });
  };

  apply();
  applyBanners();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
